import React, { useState,useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";



// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";


// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// Data
import MDButton from "components/MDButton";

import shippingdata from "../data/shippingDetailsTable";

import IconButton from "@mui/material/IconButton";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import LogoutButton from "layouts/logout";
import { useNavigate } from "react-router-dom";
import { disableBackNavigation } from "core/utils/storage";
function ShippingDetails() {
  const navigate = useNavigate();
  const { columns, rows } = shippingdata();
  useEffect(() => {
    disableBackNavigation();
  }, []);


  return (
    <DashboardLayout>
      <MDBox display="flex" justifyContent="flex-end" alignItems="center">
        <LogoutButton
          onLogout={() => {
            navigate("/login");
          }}
        />
      </MDBox>
      <DashboardNavbar />

      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >

                <MDTypography variant="h6" color="white">
                  Shipping Details Table
                </MDTypography>
              </MDBox>



              <MDBox pt={1}>
                <DataTable
                  table={{ columns, rows }}  // Use 'tableColumns' that includes the actions
                  isSorted={true}
                  entriesPerPage={true}
                  showTotalEntries={true}
                  canSearch={true}
                  noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>



      {/* <Footer /> */}
    </DashboardLayout>
  );
}

export default ShippingDetails;
